<template>
  <div>
    <div class="mt-2">
      <label class="form-label">E-mail template</label>
      <vs-select v-model="templateId" class="w-full">
        <vs-select-item
          :key="index"
          :value="item.id"
          :text="item.name"
          v-for="(item, index) in emailTemplates"
        />
      </vs-select>
    </div>

    <div class="mt-2">
      <label class="form-label">Send to</label>
      <vs-select v-model="emailSendTo" class="w-full">
        <vs-select-item
          :key="index"
          :value="item"
          :text="item | uncamelize"
          v-for="(item, index) in recipients"
        />
      </vs-select>
    </div>

    <div class="mt-2">
      <label class="form-label">Reply-to</label>
      <vs-select v-model="emailReplyTo" class="w-full">
        <vs-select-item
          :key="index"
          :value="item"
          :text="item | uncamelize"
          v-for="(item, index) in recipients"
        />
      </vs-select>
    </div>

    <div class="mt-2">
      <label class="form-label">Is marketing</label>
      <div class="vx-col w-full">
        <vs-switch
          v-model="isMarketing"
          vs-icon-off="error_outline"
          vs-icon-on="done"
        />
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";

export default {
  components: {},
  props: ["action", "automationId"],
  data() {
    return {
      isMarketing: true,
      templateId: "",
      emailSendTo: "Guest",
      emailReplyTo: "VenuePrimary",
      recipients: ["Guest", "VenuePrimary", "Booking", "LostAndFound"],
    };
  },
  methods: {
    render() {
      return {
        templateId: this.templateId,
        emailSendTo: this.emailSendTo,
        emailReplyTo: this.emailReplyTo,
        guestContactType: this.isMarketing ? "Marketing" : "Transactional",
      };
    },
  },
  computed: {
    ...mapGetters({
      triggerTypes: "automations/triggerTypes",
      emailTemplates: "emailTemplates/emailTemplates",
    }),
  },
  async mounted() {
    await this.$store.dispatch("emailTemplates/getAll", false);
    if (this.action) {
      this.emailSendTo = this.action.emailSendTo;
      this.emailReplyTo = this.action.emailReplyTo;
      this.templateId = this.action.templateId;
      this.isMarketing = this.action.guestContactType === "Marketing";
    }
  },
};
</script>

<style lang="scss" scoped>
.form-label {
  margin-bottom: 0.5rem;
  color: #5e5873;
  font-size: 0.857rem;
}
</style>

